import type { ComponentChildren } from "preact";
import { cx } from "../cx";
import { Visualizer } from "./Visualizer";

export interface DisplayPlateProps {
  /** Small tracked line above the title. */
  kicker: ComponentChildren;
  /** Id of the title heading, for `aria-labelledby`. */
  titleId: string;
  children: ComponentChildren;
  /** Bars of the little visualizer in the corner; 0 hides it. */
  bars?: number;
  class?: string;
  titleClass?: string;
}

/** Glass title display of a card: kicker, lit Exo 2 title and a visualizer. */
export function DisplayPlate({ kicker, titleId, children, bars = 10, class: cls, titleClass }: DisplayPlateProps) {
  return (
    <header class={cx("dplate", bars > 0 && "has-viz", cls)} style={bars > 0 ? { "--bars": String(bars) } : undefined}>
      <span class="dplate__kicker">{kicker}</span>
      <h1 id={titleId} class={cx("dplate__title", titleClass)}>
        {children}
      </h1>
      {bars > 0 && <Visualizer class="dplate__viz" bars={bars} />}
    </header>
  );
}
